
import { Loading } from 'element-ui';


let loading = null;

let startLoading = () => {
  loading = Loading.service({
    lock: true,
    text: '加载中........',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.6)'
  })
}
let endLoading = () => {
  loading.close();
}

export default {
  startLoading,
  endLoading
}



// WEBPACK FOOTER //
// ./src/utils/loading.js